const KEY = "ck9_attribution";

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const data = {};
    ["gclid", "utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
      const v = params.get(k);
      if (v) data[k] = v;
    });
    if (Object.keys(data).length > 0) {
      sessionStorage.setItem(KEY, JSON.stringify(data));
    }
  } catch {}
}

export function getAttribution() {
  try {
    return JSON.parse(sessionStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}
